import { getCheckoutTracking, getTrackingFromSource, getKafkaRoomsAvailability } from './utils'
import { EVENT_TYPES } from './constants'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'

export const pageView = {
  home: eventData => ({
    kafka: {
      eventName: 'homepage',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
    dataLayer: {
      sfl: {
        appStateItems: [
          'adults',
          'checkIn',
          'checkOut',
          'children',
          'country',
          'currency',
          'emailLogin',
          'language',
          'market',
          'slug',
        ],
      },
    },
  }),
  list: eventData => ({
    kafka: {
      eventName: 'hotel_list_results',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: [
        'isLoggedIn',
        'checkIn',
        'checkOut',
        'search',
        'adults',
        'children',
        'rooms',
        'userId',
      ],
    },
    dataLayer: {
      sfl: {
        appStateItems: [
          'adults',
          'checkIn',
          'checkOut',
          'children',
          'city',
          'country',
          'currency',
          'emailLogin',
          'language',
          'market',
          'nights',
          'slug',
          'searchTerm',
        ],
      },
    },
  }),
  map: eventData => ({
    kafka: {
      eventName: 'map',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: [
        'isLoggedIn',
        'checkIn',
        'checkOut',
        'mapSearch',
        'adults',
        'children',
        'rooms',
        'userId',
      ],
    },
  }),
  detail: eventData => ({
    kafka: {
      eventName: 'hotel_details',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: [
        'isLoggedIn',
        'adults',
        'checkIn',
        'checkOut',
        'children',
        'nights',
        'rooms',
        'userId',
      ],
    },
  }),
  propertyMap: eventData => ({
    kafka: {
      eventName: 'hotel_map',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: [
        'isLoggedIn',
        'adults',
        'checkIn',
        'checkOut',
        'children',
        'nights',
        'rooms',
        'userId',
      ],
    },
  }),
  login: eventData => ({
    kafka: {
      eventName: 'login',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  signUp: eventData => ({
    kafka: {
      eventName: 'signup',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  forgotPassword: eventData => ({
    kafka: {
      eventName: 'forgot-password',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  staywallet: eventData => ({
    kafka: {
      eventName: 'staywallet',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  landings: eventData => ({
    kafka: {
      eventName: 'page_view_landing',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
    dataLayer: {
      sfl: {
        appStateItems: [
          'adults',
          'checkIn',
          'checkOut',
          'children',
          'country',
          'currency',
          'language',
          'market',
          'slug',
        ],
      },
    },
  }),
  error: eventData => ({
    kafka: {
      eventName: 'error',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  checkout: ({
    affiliateId,
    board,
    device,
    ip,
    isMandatory,
    language,
    market,
    price,
    property,
    isPhysicalAddressRequired,
    provider,
    priceDropProtectionFeeBookingTotals,
  }) =>
    getCheckoutTracking({
      affiliateId,
      board,
      device,
      ip,
      isMandatory,
      language,
      market,
      price,
      property,
      eventName: 'customer_checkout',
      isPhysicalAddressRequired,
      provider,
      priceDropProtectionFeeBookingTotals,
    }),
  payment: ({ affiliateId, board, device, ip, language, market, price, property }) => ({
    kafka: {
      eventName: 'payment_checkout',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData: { affiliateId, board, device, ip, language, market, price, property },
      appStateItems: [
        'isLoggedIn',
        'adults',
        'checkIn',
        'checkOut',
        'currency',
        'children',
        'nights',
        'rooms',
        'userId',
      ],
    },
    dataLayer: {
      sfl: {
        data: {
          language,
          market,
          ip,
          device,
          property,
          affiliateId,
          board,
          price,
        },
        appStateItems: [
          'isLoggedIn',
          'adults',
          'checkIn',
          'checkOut',
          'children',
          'country',
          'currency',
          'slug',
          'purchaseEmail',
        ],
      },
      ecommerce: {
        data: {
          board,
          property,
          price,
        },
        appStateItems: ['adults', 'bestPriceData', 'currency', 'property'],
      },
    },
  }),
  thanks: ({
    affiliateId,
    board,
    bookingId,
    device,
    generatedWallet,
    ip,
    language,
    market,
    paymentMethod,
    price,
    property,
    purchaseEmail,
    purchaseId,
    firstClickAttribution,
  }) => ({
    kafka: {
      eventName: 'booking_thanks',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData: {
        affiliateId,
        board,
        bookingId,
        device,
        generatedWallet,
        ip,
        language,
        market,
        paymentMethod,
        price,
        property,
        purchaseId,
        ...(firstClickAttribution && {
          first_click_attribution: {
            aid: firstClickAttribution,
          },
        }),
      },
      appStateItems: [
        'affiliateData',
        'isLoggedIn',
        'adults',
        'checkIn',
        'checkOut',
        'currency',
        'children',
        'nights',
        'rooms',
        'userId',
        'purchaseEmailHash',
      ],
    },
    dataLayer: {
      sfl: {
        data: {
          affiliateId,
          board,
          bookingId,
          device,
          generatedWallet,
          ip,
          language,
          market,
          paymentMethod,
          price,
          property,
          purchaseEmail,
        },
        appStateItems: [
          'adults',
          'checkIn',
          'checkOut',
          'children',
          'country',
          'currency',
          'purchaseEmail',
          'slug',
        ],
      },
      ecommerce: {
        data: {
          board,
          property,
          price,
        },
        appStateItems: ['adults', 'bestPriceData', 'currency', 'property'],
      },
      conversionGA: {
        eventName: 'conversionGA',
        eventData: {
          affiliateId,
          price,
          property,
          purchaseId,
        },
      },
      iterable: {
        eventName: 'iterable',
      },
      tripadvisor: {
        eventName: 'tripadvisor',
      },
      conversionAffiliate: {
        eventName: 'conversionAffiliate',
      },
    },
  }),
  voucher: eventData => {
    const {
      affiliateId,
      board,
      bookingId,
      device,
      generatedWallet,
      ip,
      language,
      market,
      paymentMethod,
      price,
      property,
      purchaseEmail,
      purchaseId,
    } = eventData

    return {
      dataLayer: {
        sfl: {
          data: {
            affiliateId,
            board,
            bookingId,
            device,
            generatedWallet,
            ip,
            language,
            market,
            paymentMethod,
            price,
            property,
            purchaseEmail,
          },
          appStateItems: [
            'adults',
            'checkIn',
            'checkOut',
            'children',
            'country',
            'currency',
            'purchaseEmail',
            'slug',
          ],
        },
      },
      kafka: {
        eventName: 'voucher',
        eventType: EVENT_TYPES.PAGE_VIEW,
        eventData: {
          affiliateId,
          board,
          bookingId,
          device,
          generatedWallet,
          ip,
          language,
          market,
          paymentMethod,
          price,
          property,
          purchaseEmail,
          purchaseId,
        },
        appStateItems: ['isLoggedIn', 'userId'],
      },
    }
  },
  userProfile: eventData => ({
    kafka: {
      eventName: 'user_profile',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  myBookings: eventData => ({
    kafka: {
      eventName: 'my_bookings',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  hotelsSeen: eventData => ({
    kafka: {
      eventName: 'hotels_seen',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  propertiesLiked: eventData => ({
    kafka: {
      eventName: 'properties_liked',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  myStaywallet: eventData => ({
    kafka: {
      eventName: 'my_staywallet',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  myDetails: eventData => ({
    kafka: {
      eventName: 'my_details',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  myCommunicationPreferences: eventData => ({
    kafka: {
      eventName: 'my_communication_prefences',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  activateAccount: eventData => ({
    kafka: {
      eventName: 'activate_account',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  changePassword: eventData => ({
    kafka: {
      eventName: 'change_password',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  resetPassword: eventData => ({
    kafka: {
      eventName: 'reset_password',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  primeLanding: eventData => ({
    kafka: {
      eventName: 'prime_landing',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  primeThanks: eventData => ({
    kafka: {
      eventName: 'prime_thanks',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['userId'],
    },
  }),
  primeCheckout: eventData => ({
    kafka: {
      eventName: 'prime_checkout',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['userId'],
    },
  }),
  prime: eventData => ({
    kafka: {
      eventName: 'prime',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  primeReceipts: eventData => ({
    kafka: {
      eventName: 'prime_receipts',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['userId'],
    },
  }),
  primeCancel: eventData => ({
    kafka: {
      eventName: 'prime_cancel',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['userId'],
    },
  }),
  primeCancelled: eventData => ({
    kafka: {
      eventName: 'prime_cancelled',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['userId'],
    },
  }),
  invoice: eventData => ({
    kafka: {
      eventName: 'invoice',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['userId'],
    },
  }),
  reviews: eventData => ({
    kafka: {
      eventName: 'reviews',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  privacy: eventData => ({
    kafka: {
      eventName: 'privacy',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  generalConditions: eventData => ({
    kafka: {
      eventName: 'generalConditions',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  legal: eventData => ({
    kafka: {
      eventName: 'legal',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
  cookies: eventData => ({
    kafka: {
      eventName: 'cookies',
      eventType: EVENT_TYPES.PAGE_VIEW,
      eventData,
      appStateItems: ['isLoggedIn', 'userId'],
    },
  }),
}

export const loadProperties = () => ({
  dataLayer: {
    sfl: {
      appStateItems: [
        'adults',
        'checkIn',
        'checkOut',
        'children',
        'city',
        'country',
        'currency',
        'emailLogin',
        'language',
        'market',
        'nights',
        'pageId',
        'properties',
        'slug',
        'searchTerm',
      ],
    },
  },
})

export const loadPropertyWithPrice = () => ({
  dataLayer: {
    sfl: {
      appStateItems: [
        'adults',
        'bestPriceData',
        'checkIn',
        'checkOut',
        'children',
        'city',
        'country',
        'currency',
        'emailLogin',
        'language',
        'market',
        'nights',
        'property',
        'searchTerm',
        'slug',
      ],
    },
    ecommerce: {
      appStateItems: ['adults', 'bestPriceData', 'currency', 'property'],
    },
  },
})

export const loadEmailLogin = () => ({
  dataLayer: {
    sfl: {
      appStateItems: [
        'adults',
        'checkIn',
        'checkOut',
        'children',
        'city',
        'country',
        'currency',
        'device',
        'emailLogin',
        'language',
        'market',
        'nights',
        'slug',
      ],
    },
  },
})

export const loadHotelAvailabilityWithBookingRules = ({ boards, bestPriceBoard, dateFeed }) => ({
  kafka: {
    eventName: 'hotel_availability',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      roomsAvailability: getKafkaRoomsAvailability(boards),
      bestPrice: {
        board_index: bestPriceBoard,
      },
      date_feed: dateFeed,
    },
    appStateItems: [
      'adults',
      'children',
      'checkIn',
      'checkOut',
      'nights',
      'occupancies',
      'rooms',
      'property',
      'userId',
      'catalogue',
    ],
  },
})

export const clickAvailabilityRoom = ({ board, availabilityCount, propertyId }) => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      page: 'hotel_details',
      section: 'room_selected',
      propertyId,
      position: board.position || board.boardIndex,
      rateClass: board.paymentPolicy,
      totalRates: availabilityCount,
      roomImages: board.photos.length,
    },
    appStateItems: ['userId'],
  },
})

export const clickCountrySelector = () => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['clickin', 'visited', 'userId'],
    eventData: {
      section: 'dropdown_market',
    },
  },
})

export const loadModifyDatesAvailabilities = ({ totalAvailabilities = 0 } = {}) => {
  return {
    kafka: {
      eventName: 'change_dates_people',
      eventType: EVENT_TYPES.IMPRESSION,
      eventData: {
        section: SECTIONS.CHANGE_PAXES_DATES,
        context: 'booking_thanks',
        details: 'load_availabilities',
        total_availabilities: totalAvailabilities,
      },
      appStateItems: ['userId'],
    },
  }
}

export const clickMarket = destinationMarket => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['clickin', 'visited', 'userId'],
    eventData: {
      section: 'market',
      clickDetails: {
        destination_market: destinationMarket,
      },
    },
  },
})

export const loadSearchResults = searchResults => ({
  kafka: {
    eventName: 'search_results',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      searchResults,
    },
    appStateItems: [
      'adults',
      'checkIn',
      'checkOut',
      'children',
      'filters',
      'nights',
      'rooms',
      'search',
      'userId',
    ],
  },
})

export const loadSearchResultsV2 = ({
  searchResults,
  adults,
  checkIn,
  checkOut,
  children,
  filters,
  nights,
  rooms,
  search,
  userId,
}) => ({
  kafka: {
    eventName: 'search_results',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      searchResults,
      adults,
      checkIn,
      checkOut,
      children,
      filters,
      nights,
      rooms,
      search,
      userId,
    },
  },
})

export const loadMapSearchResults = searchResults => ({
  kafka: {
    eventName: 'map_search_results',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      searchResults,
    },
    appStateItems: [
      'adults',
      'checkIn',
      'checkOut',
      'children',
      'filters',
      'mapSearch',
      'nights',
      'rooms',
      'userId',
    ],
  },
})

export const clickLogoHeader = () => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      section: 'logo_header',
    },
    appStateItems: ['clickin', 'visited', 'userId'],
  },
})

export const clickFooterLink = id => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      section: 'footer',
      clickDetails: {
        section: id,
      },
    },
    appStateItems: ['clickin', 'visited', 'userId'],
  },
})

export const clickFooterSocial = id => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      section: 'footer',
      clickDetails: {
        link: id,
      },
    },
    appStateItems: ['clickin', 'visited', 'userId'],
  },
})

export const clickAuthentication = () => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      section: 'login',
    },
    appStateItems: ['clickin', 'visited', 'userId'],
  },
})

export const clickProperty = (source, { id, position, firstRoom }) => {
  const { page, section } = getTrackingFromSource(source)

  const providerName = firstRoom?.provider_name ?? ''
  const credentialSource = firstRoom?.credential_source ?? ''
  const rateClass = firstRoom?.rate_class ?? ''
  const catalogue = firstRoom?.catalogue ?? ''

  return {
    kafka: {
      eventName: 'click',
      eventType: EVENT_TYPES.CLICK,
      eventData: {
        page,
        section,
        id_property: id,
        ...position,
        ...(firstRoom && {
          c: catalogue,
          cs: credentialSource,
          p: providerName,
          r: rateClass,
        }),
      },
      appStateItems: ['adults', 'children', 'childrenAges', 'search', 'userId'],
    },
  }
}

export const clickSubmitCustomerCheckout = () => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['clickin', 'userId'],
    eventData: {
      page: 'customer_checkout',
      section: 'proceed_to_last_step',
    },
  },
})

export const clickSubmitCustomerCheckoutError = ({ insurance, insuranceAvailabilityIds }) => ({
  kafka: {
    eventName: 'checkout_validation_error',
    eventType: EVENT_TYPES.ERROR,
    appStateItems: ['clickin', 'userId'],
    eventData: {
      page: 'customer_checkout',
      section: 'proceed_to_last_step',
      insurance,
      insurance_availability_ids: insuranceAvailabilityIds,
    },
  },
})

export const clickPayNowCustomerCheckout = ({ availabilityId, isPayNow, purchaseId }) => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['clickin', 'userId'],
    eventData: {
      page: 'customer_checkout',
      section: 'pay_now',
      availabilityId,
      isPayNow,
      purchaseId,
    },
  },
})

export const clickInsuranceCustomerCheckout = ({ availabilityId, isInsured, purchaseId }) => ({
  kafka: {
    eventName: 'click',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['clickin', 'userId'],
    eventData: {
      page: 'customer_checkout',
      section: 'insurance',
      availabilityId,
      isInsured,
      purchaseId,
    },
  },
})

export const paymentConfirmation = ({ errorCode, redirect3DS }) => ({
  kafka: {
    eventName: 'payment_confirmation',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      errorCode,
      redirect3DS,
    },
    appStateItems: ['userId'],
  },
})

export const aliasCreation = ({ success }) => ({
  kafka: {
    eventName: 'alias_creation',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      success,
    },
    appStateItems: ['userId'],
  },
})

export const clickZoomCarouselDesktop = () => ({
  kafka: {
    eventName: 'photos_zoom',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['checkin', 'checkout', 'clickin', 'nights', 'occupancies', 'rooms', 'userId'],
  },
})

export const showModalSubscription = ({ action, source, url }) => ({
  kafka: {
    eventName: 'subscription_pop_up_show',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      action,
      source,
      url,
    },
    appStateItems: ['userId'],
  },
})

export const closeModalSubscription = ({ action, source, url }) => ({
  kafka: {
    eventName: 'subscription_pop_up_close',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      action,
      source,
      url,
    },
    appStateItems: ['userId'],
  },
})

export const subscriptionGdpr = ({ action, email, source, url }) => ({
  kafka: {
    eventName: 'subscription_gdpr',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      action,
      email,
      source,
      url,
    },
    appStateItems: ['userId'],
  },
})

export const sendExperimentView = ({ experiment, pageId }) => {
  const { id, key, variant } = experiment
  return {
    dataLayer: {
      experiment: {
        expId: id,
        expVar: variant,
      },
    },
    kafka: {
      eventName: 'experiment',
      eventType: EVENT_TYPES.EXPERIMENT,
      eventData: {
        experiments: [{ experiment_id: key, experiment_variant: variant }],
        page: pageId,
      },
      appStateItems: ['isLoggedIn'],
    },
  }
}

export const clickPurchaseReminderLink = ({ propertyId }) => ({
  kafka: {
    eventName: 'purchase_reminder',
    eventType: EVENT_TYPES.CLICK,
    eventData: {
      propertyId,
    },
    appStateItems: ['userId'],
  },
})

export const clickPrimeLandingCTA = () => ({
  kafka: {
    eventName: 'prime_landing_cta',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['userId'],
  },
})

export const successPrimePayment = () => ({
  kafka: {
    eventName: 'prime_success_payment',
    eventType: EVENT_TYPES.IMPRESSION,
    appStateItems: ['userId'],
  },
})

export const clickPrimeThanksCTA = () => ({
  kafka: {
    eventName: 'prime_thanks_cta',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['userId'],
  },
})

export const clickPrimeBanner = () => ({
  kafka: {
    eventName: 'prime_banner',
    eventType: EVENT_TYPES.CLICK,
    appStateItems: ['userId'],
  },
})

export const impressionPrimeBanner = () => ({
  kafka: {
    eventName: 'prime_banner',
    eventType: EVENT_TYPES.IMPRESSION,
    appStateItems: ['userId'],
  },
})

export const showPurchaseReminder = ({ propertyId }) => ({
  kafka: {
    eventName: 'purchase_reminder',
    eventType: EVENT_TYPES.IMPRESSION,
    eventData: {
      propertyId,
    },
    appStateItems: ['userId'],
  },
})

export const checkoutError = ({ error }) => {
  // This assumes an error we are interested mainly in axios errors that is why
  // we are checking for the particular object shape
  const errorMessage = error?.response?.data?.error || null
  const errorCode = error?.response?.data?.code || null
  const httpCode = error?.response?.status || null
  return {
    kafka: {
      eventName: 'checkout_error',
      eventType: EVENT_TYPES.ERROR,
      eventData: {
        errorMessage,
        errorCode,
        httpCode,
      },
      appStateItems: ['pageId', 'device', 'userId', 'market'],
    },
  }
}

export const checkoutErrorFrom200 = ({ response }) => {
  // This assumes an error we are interested mainly in axios errors that is why
  // we are checking for the particular object shape
  const errorMessage = response?.error || null
  const errorCode = response?.code || null
  const httpCode = 200
  return {
    kafka: {
      eventName: 'checkout_error',
      eventType: EVENT_TYPES.ERROR,
      eventData: {
        errorMessage,
        errorCode,
        httpCode,
      },
      appStateItems: ['pageId', 'device', 'userId', 'market'],
    },
  }
}

export const checkoutIntent = ({
  reason,
  context,
  status,
  purchaseId,
  details,
  eventName = 'purchase_attempt',
  ...payloadProps
}) => {
  return {
    kafka: {
      eventName,
      eventType: EVENT_TYPES.IMPRESSION,
      eventData: {
        reason,
        context,
        status,
        purchaseId,
        details,
        ...payloadProps,
      },
      appStateItems: [
        'adults',
        'affiliateId',
        'checkIn',
        'checkOut',
        'children',
        'device',
        'isLoggedIn',
        'market',
        'pageId',
        'property',
        'userId',
        'rooms',
      ],
    },
  }
}

export const pageviewIterableHotelPage = () => ({
  emt: {
    eventName: 'page_view_hotel',
    eventType: EVENT_TYPES.PAGE_VIEW,
    appStateItems: [
      'adults',
      'affiliateId',
      'alertMessage',
      'bestPriceData',
      'checkIn',
      'checkOut',
      'children',
      'childrenAges',
      'city',
      'country',
      'currency',
      'emailLogin',
      'isLoggedIn',
      'language',
      'market',
      'property',
      'purchaseEmail',
      'slug',
    ],
  },
})

export const pageviewIterableResultsPage = eventData => ({
  emt: {
    eventName: 'page_view_destination',
    eventType: EVENT_TYPES.PAGE_VIEW,
    eventData,
    appStateItems: [
      'adults',
      'affiliateId',
      'checkIn',
      'checkOut',
      'children',
      'childrenAges',
      'city',
      'citySlug',
      'country',
      'currency',
      'emailLogin',
      'isLoggedIn',
      'language',
      'market',
      'purchaseEmail',
      'slug',
    ],
  },
})

export const kafkaDirectEvent = ({ eventName, ...eventData }) => ({
  kafkaDirect: {
    eventName,
    eventType: null,
    eventData,
    appStateItems: [
      'adults',
      'affiliateData',
      'affiliateId',
      'boards',
      'checkIn',
      'checkOut',
      'children',
      'childrenAges',
      'city',
      'citySlug',
      'country',
      'currency',
      'emailLogin',
      'isLoggedIn',
      'language',
      'market',
      'purchaseEmail',
      'slug',
      'voucher',
    ],
  },
})

export const sendViewCommentsEvent = data => {
  const { reviews: comments, property } = data
  const numComments = comments.length
  const avgRate =
    numComments > 0 ? comments.reduce((acc, comment) => acc + comment.stars, 0) / numComments : 0

  const source = property ? property.source : 'tripadvisor' // This is to send the correct source when the new endpoint is ready
  const eventData = {
    section: 'view_comments',
    num_comments: numComments,
    avg_rate: avgRate.toFixed(2),
    source,
  }
  return {
    kafka: {
      eventName: SECTIONS.VIEW_COMMENTS,
      eventType: EVENT_TYPES.IMPRESSION,
      eventData,
      appStateItems: [
        'adults',
        'children',
        'checkIn',
        'checkOut',
        'nights',
        'occupancies',
        'rooms',
        'property',
        'userId',
        'catalogue',
      ],
    },
  }
}
